import { concat } from '@ember/helper';
import Component from '@glimmer/component';
import range from '@nullvoxpopuli/ember-composable-helpers/helpers/range';
import t from 'ember-intl/helpers/t';
import type { Signature as ProviderSig } from 'parog-web/components/forc/provider';
interface Signature {
  Args: {
    form: ProviderSig['Blocks']['content'][0];
  };
}

const prostateMutations = ['brca2', 'brca1', 'atm', 'cdk12', 'chek2', 'hoxb13'];

export default class MedicalHistoryFormPancreaticCancerPathologyComponent extends Component<Signature> {
  get prostateMutations(): string[] {
    return prostateMutations;
  }

  <template>
    {{!     Prostatee cancer type     }}
    <div class='field'>
      <@form.BasicRadioGroup
        @title='Type du cancer'
        @propertyName='prostateCancerType'
        as |Group|
      >
        <div class='fields inline'>
          <div class='field'>
            <Group.Radio @label='Adénocarcinome' @value='adenocarcinoma' />
          </div>
        </div>
      </@form.BasicRadioGroup>
    </div>

    <div class='field'>
      <@form.AlignedFieldsRadioGroup
        @propertyName='hormoneSensitiveCancer'
        @title='Cancer hormonosensible'
        as |Group|
      >
        <Group.FieldRadio @label='Oui' @value={{true}} />
        <Group.FieldRadio @label='Non' @value={{false}} />
      </@form.AlignedFieldsRadioGroup>
    </div>

    {{!     Mutation Génétique    }}

    <div class='field'>
      <@form.Dropdown
        @labelName='Mutation'
        @propertyName='prostateMutation'
        @multipleSelection={{true}}
        as |dropdown|
      >
        {{#each this.prostateMutations as |prostateMutation|}}
          <dropdown.Item
            @key={{prostateMutation}}
            @value={{t
              (concat
                'fur.cancer-medical-history.prostate-mutations.'
                prostateMutation
              )
            }}
          />
        {{/each}}
      </@form.Dropdown>
    </div>

    <div class='ten wide field'>
      <@form.BasicRadioGroup
        @title='Score de Gleason'
        @propertyName='gleasonScore'
        as |Group|
      >
        <div class='fields inline'>
          {{#each (range 1 11) as |number|}}
            <div class='field'>
              <Group.Radio @label='{{number}}' @value='{{number}}' />
            </div>
          {{/each}}
        </div>
      </@form.BasicRadioGroup>
    </div>
  </template>
}
